import { BenchmarkingItem, CommonProps } from '@/stores/benchmarking-store';
import { useFormatters } from '@/utils/formatters/useFormatters';
import { getBenchmarkingPresentation } from '@/utils/scenario-presentation';
import { useTranslation } from 'react-i18next';
import { useTransferPair } from './useTransferPair';

export function useBenchmarkingPresentation(commonProps: CommonProps, item: Omit<BenchmarkingItem, 'id'>) {
  const { t } = useTranslation();
  const formatters = useFormatters();

  const { data, loading, error } = useTransferPair({
    concept: item.invoicingConcept,
    customerId: item.customerId,
    vendorId: item.vendorId,
    invoicingCurrency: 'USD',
  });

  const presentation = data
    ? getBenchmarkingPresentation(
      commonProps,
      item,
      data,
      t,
      formatters
    )
    : null;

  return { presentation, loading, error };
}
